module.exports = __webpack_public_path__ + "img/01.eee40a44.jpg";